export function exportar(arquivo, tipo, titulo) {
    if (tipo === 'print') {
        print(arquivo);
        return;
    }

    const extensao = tipo === 'excel' ? 'xls' : tipo;
    download(arquivo, titulo, extensao);
}

export async function b64toBlob(base64, type = 'application/octet-stream') {
    const res = await fetch(`data:${type};base64,${base64}`);
    return res.blob();
}

export function blobToFile(blob, name, type = 'application/pdf') {
    return new File([blob], name, { type: type });
}

export function blobToB64(blob) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

export async function prepareFile(file) {
    if (typeof file?.anexo === 'string') {
        const nome = file?.nome ?? `arquivo.${file?.contentType.split('/')[1]}`;
        const value = await b64toBlob(file.anexo, file?.contentType);
        return blobToFile(value, nome, value.type);
    } else if (file.name) {
        return file;
    } else {
        return null;
    }
}

export function download(arquivo, titulo, extensao) {
    const url = window.URL.createObjectURL(arquivo);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', extensao ? `${titulo}.${extensao}` : `${titulo}`); //or any other extension
    document.body.appendChild(link);
    link.click();
    link.remove();
}

function print(arquivo) {
    if (window.frames['print_pdf']) document.body.removeChild(window.frames['print_pdf']);

    const url = window.URL.createObjectURL(arquivo);
    const iframe = document.createElement('iframe'); //load content in an iframe to print later
    document.body.appendChild(iframe);

    iframe.style.display = 'none';
    iframe.src = url;
    iframe.id = 'print_pdf';
    iframe.name = 'print_pdf';
    iframe.onload = () => {
        setTimeout(function () {
            iframe.focus();
            iframe.contentWindow.print();
        }, 1);
    };
}
